import ListFields from '../fragments/ListFields';

export default (languageCode: string) => /* GraphQL */ `
    mutation CreateList($name: String!) {
        list: createList(name: $name, setSelected: true) {
            ...ListFields
        }
    }
    ${ListFields(languageCode)}
`;
